var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 6.03646C6.66797 6.92051 7.01916 7.76836 7.64428 8.39348C8.2694 9.0186 9.11725 9.36979 10.0013 9.36979C10.8854 9.36979 11.7332 9.0186 12.3583 8.39348C12.9834 7.76836 13.3346 6.92051 13.3346 6.03646C13.3346 5.1524 12.9834 4.30456 12.3583 3.67944C11.7332 3.05431 10.8854 2.70313 10.0013 2.70312C9.11725 2.70313 8.2694 3.05431 7.64428 3.67944C7.01916 4.30456 6.66797 5.1524 6.66797 6.03646Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.2969V15.6302C5 14.7462 5.35119 13.8983 5.97631 13.2732C6.60143 12.6481 7.44928 12.2969 8.33333 12.2969H11.6667C12.5507 12.2969 13.3986 12.6481 14.0237 13.2732C14.6488 13.8983 15 14.7462 15 15.6302V17.2969",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_4739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/icon-people.d24c7db6557776e608933e79d827f47c.svg";
export { ForwardRef as ReactComponent };